import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PT from 'prop-types';
import classNames from 'classnames';
import { Table } from 'semantic-ui-react';
import moment from 'moment';
import { groupBy } from 'lodash';
import classes from './nflSchedule.css';
import Link from '../../../lib/components/link';
import { selectNFLScheduleState, NFL_SCHEDULE_GRID_VIEW, NFL_SCHEDULE_GRID_SUBVIEW, SET_NFL_SCHEDULE_WEEK } from './module/nflSchedule';
// import FiltersHeader from '../../components/FiltersHeader';
import TableControls from '../../components/TableControls';
import PlainTable from '../../components/DataTable/PlainTable';
import { selectTeams } from '../../../store/reducers/teams.selectors';
import MatchupCell from '../../components/DataTable/StatCells/MatchupCell';
import { selectControlsState } from '../../../store/reducers/tableControls';
import YearDropdown from '../../components/FilterComponents/YearDropdown';
import { selectYearsForDropdown } from '../../../store/reducers/season';


const pageTitle = 'NFL Schedule';


const ScheduleTabMenu = ({ activePage, handleClick }) => {
  const tabClass = view => classNames({
    [classes.menuTab]: true,
    active: view === activePage,
  });

  return (
    <ul className={classes.tabMenuContainer} role="menubar">
      <li onClick={() => handleClick('full-schedule')} className={tabClass('full-schedule')} role="menuitem">Full Schedule</li>
      <li onClick={() => handleClick('weekly-grid')} className={tabClass('weekly-grid')} role="menuitem">Weekly Grid</li>
      <li onClick={() => handleClick('team-grid')} className={tabClass('team-grid')} role="menuitem">Team Grid</li>
      <li onClick={() => handleClick('bye-weeks')} className={tabClass('bye-weeks')} role="menuitem">Bye Weeks</li>
    </ul>
  );
};

ScheduleTabMenu.propTypes = {
  activePage: PT.string.isRequired,
  handleClick: PT.func.isRequired,
};

class NFLSchedule extends PureComponent {
  /*static propTypes = {
    hasLoaded: PT.bool.isRequired,
    selectedYear: PT.number.isRequired,
    matchups: PT.arrayOf(PT.object).isRequired,
    teams: PT.arrayOf(PT.object),
  };*/

  static defaultProps = {
    matchupsByTeam: [],
    weekNumber: null,
  }

  prepHeaders = () => {
    const showStart = 1;
    const showEnd = this.props.selectedYear >= 2021 ? 18 : 17;
    const colKeys = [];
    const colLabels = [];
    const colKeysWeekly = [];
    const colLabelsWeekly = [];
    for (let i = showStart; i <= showEnd; i++) {
      colKeysWeekly.push(String(i - 1));
      colLabelsWeekly.push(`${i}`);
    }
    colKeys.push('team_abbr'); // need to manually add the team column key/label
    colLabels.push('Team');
    for (let i = showStart; i <= showEnd; i++) {
      colKeys.push(String(i - 1));
      colLabels.push(`Wk ${i}`);
    }
    return { colKeys, colLabels, colKeysWeekly, colLabelsWeekly };
  };

  prepStats = colKeys => {
    const { matchups, hasLoaded, teams } = this.props;
    let allStatRows = [];
    if (hasLoaded) {
      allStatRows = Object.values(teams).filter(team => team && team.abbr).map(team => {
        const statRow = {};
        if (team) {
          const teamAbbr = team.abbr;
          statRow.team_abbr = teamAbbr;
          colKeys.forEach(key => {
            if (key !== 'team_abbr') {
              const gameObject = matchups[key].find(game => game.away_team_abbr === teamAbbr ||
                game.home_team_abbr === teamAbbr);
              let opponent = 'BYE';
              if (gameObject) {
                opponent = gameObject.home_team_abbr === teamAbbr ? gameObject.away_team_abbr : `@${gameObject.home_team_abbr}`;
              }
              statRow[key] = {
                element:
                <MatchupCell className={classes.matchup}>
                  {`${opponent}`}
                </MatchupCell>,
              };
            }
          });
        }
        return statRow;
      });
    }
    return allStatRows;
  }

  prepStatsWeekly = colKeys => {
    const { hasLoaded, matchupsByWeek, selectedYear } = this.props;
    const allStatRows = [];
    const weeks = this.prepTeamAbbreviations(matchupsByWeek);
    const teams = ['HOU', 'DET', 'WAS', 'DAL', 'BAL', 'PIT', 'ARI', 'NE', 'TEN', 'IND', 'NYG', 'CIN', 'LAC', 'BUF', 'LVR', 'ATL', 'CLE', 'JAC', 'MIA', 'NYJ', 'CAR', 'MIN', 'NO', 'DEN', 'SF', 'LAR', 'KC', 'TB', 'CHI', 'GB', 'SEA', 'PHI'];
    const completeWeeks = Array.from({ length: selectedYear >= 2021 ? 18 : 17 }, (_, index) => {
      if (weeks[index] === undefined) {
        return [];
      }
      return weeks[index];
    });

    const gamesPerWeek = completeWeeks.map(week => {
      const bye = teams.filter(team => week.every(game => game.home_team_abbr !== team &&
        game.away_team_abbr !== team));
      if (bye.length !== 0) {
        return [
          ...week,
          {
            btby: bye.join(',\n'),
            rowSpan: 17 - week.length,
          },
        ];
      }
      return [...week];
    });
    if (hasLoaded) {
      const matchups = gamesPerWeek[0].map((_, colIn) => gamesPerWeek.map(row => row[colIn]));
      matchups.forEach(week => {
        const statRow = {};
        colKeys.forEach(key => {
          if (week[key] !== undefined) {
            if (week[key].home_team_abbr === undefined) {
              statRow[key] = {
                element: (
                  <MatchupCell day={'bye'}>
                    {`${week[key].btby}\n`}
                  </MatchupCell>),
                rowSpan: week[key].rowSpan,
                byeCell: true,
              };
            } else {
              statRow[key] = {
                element: (
                  <MatchupCell country={week[key].venue_country} day={moment.parseZone(week[key].start_date).format('dddd')}>
                    {`${week[key].away_team_abbr} \n @ \n ${week[key].home_team_abbr}`}
                  </MatchupCell>
                ),
                byeCell: false,
              };
            }
          } else {
            statRow[key] = {
              element: <div />,
              rowSpan: 0,
              byeCell: false,
            };
          }
        });
        allStatRows.push(statRow);
      });
    }
    return allStatRows;
  };

  prepTeamAbbreviations = () => {
    const { hasLoaded, teams, matchupsByWeek } = this.props;
    if (hasLoaded && teams) {
      matchupsByWeek.forEach(week => {      
        week.forEach(matchup => {
          Object.values(teams).forEach(team => {
            if (team) {
              if (matchup.home_team_id === team.id) {
                  matchup.home_team_abbr = team.abbr;
              }
              if (matchup.away_team_id === team.id) {
                  matchup.away_team_abbr = team.abbr;
              }
            }
          });
        });
      });
    }
    return matchupsByWeek;
  }

  prepMatchups = colKeys => {
    const { teams } = this.props;;
    const allStatRows = [];
    let teamsInfo = [];

    // Filtered teams to create the matchups rows
    Object.values(teams).map(team => {
      if (team != 'undefined') {
        if (team && typeof team.abbr != 'undefined' && team.abbr != 'IP_' && team.abbr != 'FA') {
          const { id, abbr, name } = team;
          teamsInfo = [...teamsInfo, { id, abbr, name }];
        }
      }
    });
    return allStatRows;
  };

  handleWeekNumber = (matchups, selectedWeek, wrapperClassFullSchedule) => {
    if (selectedWeek === 0) {
      return Object.values(matchups).map((week, index) => {
        return week && week.length
        ? this.renderWeeklyTable(week, index, wrapperClassFullSchedule)
        : null;
      });
    }
    return this.renderWeeklyTable(
      Object.values(matchups)[selectedWeek - 1] || [],
      selectedWeek - 1,
      wrapperClassFullSchedule,
    );
  }

  handleWeekChange = (event, data) => {
    let value;
    if (data === undefined) {
      value = event.target.value;
    } else {
      value = data.value;
    }
    const { goToWeek, currentWeek } = this.props;
    if (currentWeek !== value) goToWeek(value);
  }

  createCountryList = () => {
    const {matchupsByWeek} = this.props;
    let cityList = [];
    const citybyCountry = {
      'DEU': 'frankfurt',
      'MEX': 'mexicoCity',
      'ENG': 'london'

    };

    matchupsByWeek.forEach((week)=>{
      cityList.push(... week.filter(matchup => matchup.venue_country != null && matchup.venue_country != '' && matchup.venue_country != 'USA').reduce( (cities, matchup) => {
        if (!cityList.includes(citybyCountry[matchup.venue_country])){
          cities.push(citybyCountry[matchup.venue_country])
        }
        return cities;
      }, []))
    })

    return cityList;
  }

  handleTableControls = subview => {
    let controlComponent = null;
    switch (subview) {
      // case 'full-schedule': return <TableControls />;
      case 'full-schedule':
        controlComponent = <TableControls jumpToWeek onChangeWeek={this.handleWeekChange} />;
        break;
      case 'weekly-grid':
        controlComponent = <TableControls scheduleDetails density={false} countryList={this.createCountryList()}/>;
        break;
      case 'team-grid':
        controlComponent = <TableControls hideStatsKey colGroups={[{ columns: ['team', 'Week #'] }]} />;
        break;
      case 'bye-weeks':
        controlComponent = <TableControls />;
        break;
      default:
        controlComponent = <TableControls />;
        break;
    }

    return (
      <div className={classes.tableControlsWrapper}>
        {controlComponent}
      </div>
    );
  }

  handleChangeProfile = (event, { value }) => {
    if (this.props.selectedProfile !== value) {
      this.props.goToView(NFL_SCHEDULE_GRID_VIEW, { query: { formulaId: value } });
    }
  }

  handleChangeYear = (event, { value }) => {
    const { goToView, selectedYear, selectedProfile } = this.props;
    if (selectedYear !== value) goToView(value, selectedProfile);
  };

  handleTabClick = subview => {
    this.props.changeSubview(subview);
  }

  renderByeTable = (byeWeek, wrapperClassByeTeams) => {
    return (
      <div className={wrapperClassByeTeams}>
        <Table unstackable celled striped>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell style={{ width: '25%' }} textAlign="left"><b>Schedule</b></Table.HeaderCell>
              <Table.HeaderCell style={{ width: '75%' }} textAlign="left">Teams</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {byeWeek.map(week => this.renderByeRow(week))}
          </Table.Body>
        </Table>
      </div>
    );
  }

  renderByeRow = byeWeek => {
    const { week, bye_teams } = byeWeek;
    return (
      <Table.Row key={week * Math.random()}>
        <Table.Cell style={{ width: '20%' }} textAlign="left"><b>{`Week ${week}`}</b></Table.Cell>
        <Table.Cell style={{ width: '80%' }} textAlign="left">{bye_teams.replace(/,/g, ', ')}</Table.Cell>
      </Table.Row>
    );
  }

  renderDateRow = (date, row) => {
    const { game_id, away_team_city, away_team_name, home_team_city, home_team_name, start_date, published } = date;
    if (start_date) {
      const dateObject = moment.parseZone(start_date);
      return (
        <Table.Row key={game_id} value={row}>
          <Table.Cell style={{ width: '75%' }} textAlign="left">
            {published ?
              <Link className={classes.link}
                    to={`/in-season/predictions/analysis/${game_id}/1`}>{`${away_team_city} ${away_team_name} at ${home_team_city} ${home_team_name}`}</Link>
              : <span className={classes.linkDisabled}>{`${away_team_city} ${away_team_name} at ${home_team_city} ${home_team_name}`}</span>
            }
          </Table.Cell>
          <Table.Cell style={{ width: '25%' }} textAlign="center">
          <span className={published?'':classes.linkDisabled}>{dateObject.format('h:mm a')}</span>
          </Table.Cell>
        </Table.Row>
      );
    }
    return null;
  }

  renderWeeklyTable = (dates, index, wrapperClassFullSchedule) => {
    // Grouped weeks by day
    const { byeTeamsByWeek } = this.props;
    const initialWeek = dates.map(week => ({
      date: week.start_date ? week.start_date.substring(0, 10) : null, ...week,
    }));
    const groupedWeek = groupBy(initialWeek, 'date');
    const weeks = Object.values(groupedWeek);
    const byeTeams = byeTeamsByWeek.find(week => week.week === index + 1);
    let numberOfRows = 0;
    return (
      <div key={Math.random()} id={index + 1} className={classes.tablesWrapper}>
        <Table unstackable celled striped className={wrapperClassFullSchedule}>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell style={{ width: '75%' }} textAlign="left"><b>{`Week ${index + 1}`}</b></Table.HeaderCell>
              <Table.HeaderCell style={{ width: '25%' }} textAlign="center">Time (ET)</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          {weeks.map(day => {
            if (day[0].game_id) {
              numberOfRows += 1;
              return (
                <Table.Body key={day[0].game_id}>
                  <Table.Row value={numberOfRows}>
                    <Table.Cell
                      style={{ width: '75%' }}
                      className={classes.matchupCell}
                      textAlign="left"
                    >
                      <b>{moment.parseZone(day[0].start_date).format('dddd, MMMM Do')}</b>
                    </Table.Cell>
                    <Table.Cell style={{ width: '25%' }} className={classes.matchupCell} />
                  </Table.Row>
                  {day.sort((a, b) => a.start_date.localeCompare(b.start_date)).map(game => {
                    numberOfRows += 1;
                    return this.renderDateRow(game, numberOfRows);
                  })}
                </Table.Body>
              );
            }
            return null;
          })}
          <Table.Body>
            <Table.Row value={numberOfRows + 1} >
              <Table.Cell
                style={{ width: '75%' }}
                className={classes.matchupCell}
                textAlign="left"
              >
                <b>BYE: </b>{byeTeams ? byeTeams.bye_teams.replace(/,/g, ', ') : ''}
              </Table.Cell>
              <Table.Cell style={{ width: '25%' }} className={classes.matchupCell} />
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    );
  }

  render() {
    const {
      byeTeamsByWeek,
      currentSubview,
      matchups,
      hasLoaded,
      selectedProfile,
      selectedYear,
      output,
      matchupsByWeek,
      week,
      currentWeek,
      years
    } = this.props;
    const hasData = Object.values(matchups)[0];
    let activeSubview;
    switch (currentSubview) {
      case 'full-schedule': activeSubview = 'Full Schedule by Week'; break;
      case 'weekly-grid': activeSubview = 'Weekly Grid'; break;
      case 'team-grid': activeSubview = 'Team by Week Grid'; break;
      case 'bye-weeks': activeSubview = 'Bye Weeks'; break;
      default: activeSubview = 'Full Schedule by Week';
    }

    const wrapperClass = classNames(
      classes.gridTable,
      { [classes.collapsed]: this.props.collapsed },
    );

    const wrapperClassFullSchedule = classNames(
      classes.fullSchedule,
      { [classes.collapsed]: this.props.collapsed },
    );
    const wrapperClassByeTeams = classNames(
      classes.byeTeamsTable,
      { [classes.collapsed]: this.props.collapsed },
    );

    const { colKeys, colLabels, colKeysWeekly, colLabelsWeekly } = this.prepHeaders();
    const colGroups = [{ name: '', columns: colKeys, colLabels }];
    const allMatchupsRows = this.prepStats(colKeys);
    const colGroupsWeekly = [{ name: '', columns: colKeysWeekly, colLabels: colLabelsWeekly }];
    const allMatchupsRowsWeekly = this.prepStatsWeekly(colKeysWeekly);

    return (
      <div className={classes.wrapper}>
        <YearDropdown
          years={years}
          selectedYear={selectedYear}
          onChangeYear={this.handleChangeYear}
        />
        <h1 className={classes.heading}>{`${pageTitle} - ${activeSubview}`}</h1>

        {/* <FiltersHeader
          title={`${pageTitle} - ${activeSubview}`}
          seasonType="seasons"
          statType="projections"
          selectedYear={selectedYear}
          selectedProfile={selectedProfile}
          onChangeYear={this.handleChangeYear}
          offFilters={false}
          onChangeProfile={this.handleChangeProfile}
        /> */}
        <ScheduleTabMenu
          handleClick={this.handleTabClick}
          activePage={currentSubview}
        />
        {this.handleTableControls(currentSubview)}
        <div className={classes.tablesWrapper}>
          {/* hasLoaded && hasData && currentSubview === 'full-schedule' && Object.values(matchups).map((week, index) => week && week.length ? this.renderWeeklyTable(week, index) : null) */}
          {/*hasLoaded && hasData && currentSubview === 'full-schedule' && this.renderWeeklyTable(Object.values(matchups)[selectedWeek], selectedWeek)*/}
          {hasLoaded && hasData && currentSubview === 'full-schedule'
            && this.handleWeekNumber(matchups, currentWeek, wrapperClassFullSchedule)}
          { hasLoaded && currentSubview === 'weekly-grid' ?
            <PlainTable
              centerFirstCol
              className={classes.gridWeeklyTable}
              colGroups={colGroupsWeekly}
              data={allMatchupsRowsWeekly}
              equalWidthCols
              fittedText
              fixFirstColumn={false}
              sortAscending={false}
              disableSort
            />
            : null
          }
          { hasLoaded && currentSubview === 'team-grid' ?
            <PlainTable
              centerFirstCol
              className={wrapperClass}
              colGroups={colGroups}
              data={allMatchupsRows}
              fittedText
              initialSortColumn={'team_abbr'}
              equalWidthCols
              disableSort={false}
              sortFirstColumn
            /> : null
          }
          { hasLoaded && currentSubview === 'bye-weeks' && this.renderByeTable(byeTeamsByWeek, wrapperClassByeTeams) }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const {
    byeTeamsByWeek,
    currentSubview,
    hasLoaded,
    matchups,
    formulaId,
    year,
    week,
    currentWeek,
  } = selectNFLScheduleState(state);
  const teams = selectTeams(state);
  const matchupsByWeek = Object.values(matchups);
  const allYears = selectYearsForDropdown(state, 'seasons', 'projections');

  return {
    byeTeamsByWeek,
    currentWeek,
    currentSubview,
    hasLoaded,
    matchups,
    selectedProfile: formulaId,
    selectedYear: year,
    teams,
    week,
    years: allYears.filter(item => item.value >= 2015),
    matchupsByWeek,
    collapsed: selectControlsState(state).collapsed,
  };
};

const mapDispatchToProps = dispatch => ({
  changeSubview: subview => dispatch({ type: NFL_SCHEDULE_GRID_SUBVIEW, payload: { subview } }),
  goToView: (value, selectedProfile) => dispatch({
    type: NFL_SCHEDULE_GRID_VIEW,
    payload: {
      query: {
        year: value,
        formulaId: selectedProfile,
      },
      updateQuery: false,
    },
  }),
  goToWeek: value => dispatch({
    type: SET_NFL_SCHEDULE_WEEK,
    payload: { currentWeek: value },
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(NFLSchedule);



// WEBPACK FOOTER //
// ./src/app/views/NFLSchedule/NFLSchedule.js